import React, { useState } from 'react'
import ImessManagement from '../components/ImessManagement/ImessManagement'

const ImessManagementPage = () => {
  return <ImessManagement />
}

export default ImessManagementPage
